export default {
  computed: {
    storeActions () {
      return (this.$store.state.actionsTray.actionsTray || []).map(item => {
        if (item._compiled) {
          return { component: item, props: {} }
        }

        return item
      })
    },
    filteredActions () {
      return this.storeActions
        .filter(action => {
          return [
            'file-viewer-fullscreen-action',
            'file-share-action',
            'file-video-call',
            'file-viewer-download-action',
            'files-compare-studies',
            'files-filter-action',
            'files-recents-filter-action',
            'file-toggle-view',
            'files-toggle-view',
            'files-info-action',
            'files-comment-action'
          ].includes(action.component.name)
        })
    },
    showActionTrayDrawerMenu () {
      return this.filteredActions.length > 0 && this.$store.getters['session/isAuthenticated'] && this.$vuetify.breakpoint.xsOnly
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/actions-tray/ActionsTray.js